import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import QuickAccess from '../../services/quick-access';
import QuickAccessAddPanel from './QuickAccessAddPanel';

/**
 * Dropdown "Xem nhanh" trên header — user tự pin shortcut chức năng hay dùng
 * (nhãn tự đặt + link route thật + icon), lưu per-user ở server.
 * Tự quản lý open state + outside-click; token đính kèm tự động qua request().
 */
export default function QuickAccessDropdown() {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const [items, setItems] = useState([]);
    const [mode, setMode] = useState('list'); // 'list' | 'add'

    const rootRef = useRef(null);

    useEffect(() => {
        const onClickOutside = (e) => {
            if (rootRef.current && !rootRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', onClickOutside);
        return () => document.removeEventListener('mousedown', onClickOutside);
    }, []);

    const load = () => {
        setLoading(true);
        QuickAccess.getMyQuickAccess((res) => {
            setLoading(false);
            setLoaded(true);
            if (res && res.success) {
                setItems(Array.isArray(res.data) ? res.data : []);
            } else {
                // API chưa deploy hoặc lỗi -> danh sách rỗng, không chặn UI.
                setItems([]);
            }
        });
    };

    const toggle = (e) => {
        e.stopPropagation();
        if (!open && !loaded && !loading) {
            load();
        }
        setOpen((v) => !v);
        setMode('list');
    };

    const openAdd = () => setMode('add');

    const onCreated = (item) => {
        setItems((prev) => [...prev, item]);
        setMode('list');
    };

    const remove = (id) => {
        QuickAccess.deleteQuickAccess(id, (res) => {
            if (res && res.success) {
                setItems((prev) => prev.filter((it) => it.id !== id));
            } else {
                toast.error('Không xóa được shortcut');
            }
        });
    };

    const move = (index, dir) => {
        const next = [...items];
        const target = index + dir;
        if (target < 0 || target >= next.length) return;
        const tmp = next[index];
        next[index] = next[target];
        next[target] = tmp;
        setItems(next);
        QuickAccess.reorderQuickAccess(next.map((it) => it.id), () => {});
    };

    return (
        <div className={`quick-access-dropdown ${open ? 'open' : ''}`} ref={rootRef}>
            <button className="quick-access-btn" onClick={toggle} type="button" title="Xem nhanh">
                <i className="fas fa-bolt" />
                <span>Xem nhanh</span>
                <i className="fas fa-chevron-down caret" />
            </button>

            <div className="quick-access-menu">
                <div className="qa-header">
                    <span className="qa-title">
                        <i className="fas fa-bolt" /> Xem nhanh
                    </span>
                    {mode === 'list' ? (
                        <button className="qa-add-btn" type="button" onClick={openAdd}>
                            <i className="fas fa-plus" /> Thêm
                        </button>
                    ) : (
                        <button className="qa-add-btn ghost" type="button" onClick={() => setMode('list')}>
                            <i className="fas fa-arrow-left" /> Quay lại
                        </button>
                    )}
                </div>

                {mode === 'list' && (
                    <div className="qa-body">
                        {loading && <div className="qa-empty">Đang tải…</div>}
                        {!loading && items.length === 0 && (
                            <div className="qa-empty">
                                Chưa có mục nào.<br />Bấm <b>＋ Thêm</b> để ghim chức năng hay dùng.
                            </div>
                        )}
                        {!loading && items.length > 0 && (
                            <div className="qa-grid">
                                {items.map((it, idx) => (
                                    <div className="qa-card" key={it.id}>
                                        <Link className="qa-link" to={it.url} onClick={() => setOpen(false)}>
                                            <span className="qa-icon">
                                                <i className={it.icon || 'fas fa-star'} />
                                            </span>
                                            <span className="qa-label" title={it.label}>{it.label}</span>
                                        </Link>
                                        <div className="qa-controls">
                                            <button type="button" title="Lên" disabled={idx === 0}
                                                onClick={() => move(idx, -1)}>
                                                <i className="fas fa-chevron-up" />
                                            </button>
                                            <button type="button" title="Xuống" disabled={idx === items.length - 1}
                                                onClick={() => move(idx, 1)}>
                                                <i className="fas fa-chevron-down" />
                                            </button>
                                            <button type="button" className="danger" title="Xóa"
                                                onClick={() => remove(it.id)}>
                                                <i className="fas fa-times" />
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                )}

                {mode === 'add' && <QuickAccessAddPanel onCreated={onCreated} />}
            </div>
        </div>
    );
}
